module.exports = __webpack_public_path__ + "static/media/2017.8132aa1d.png";